export default __webpack_public_path__ + "static/media/20.a27c71a0.png";